const miguplay=require('../assets/home/onlinePlatform/CloudGame.svg');
const playStation=require('../assets/home/onlinePlatform/PS.svg');
const PC=require('../assets/home/onlinePlatform/PC.svg');
const SwitchConsole=require('../assets/home/onlinePlatform/switch.svg');
const xbox=require('../assets/home/onlinePlatform/xbox.svg');
const IOS=require('../assets/home/onlinePlatform/IOS.svg');
const android=require('../assets/home/onlinePlatform/android.svg');
const Arcade=require('../assets/home/onlinePlatform/Arcade.svg');
export default {
    NavBar: {
        Home: "Home",
        Partner: "Partner",
        Games: "Games",
        News: "News",
        Weibo: "Weibo",
        Aboutus: "About us",
        language: "Languages",
        zh: "Chinese",
        en: "English",
    },
    ButtonText: {
        DETAILS: "LEARN MORE",
        WATCHTRAILER: "WATCH TRAILER",
        LEARNMORE: "LEARN MORE",
        BUYNOW: "BUY NOW",
        OFFICIALSITE: "OFFICIAL SITE"
    },
    Home: {
        // KVcount:5+1
        KVData:[
            {
                id:1,
                logo:require('../assets/home/FenyxRising-logo.png'),
                title:"The open adventure game of the fantasy world 'Immortals Fenyx Rising'",
                subtitle:"Produced by the original team of Assassin's Creed: Odyssey",
                onlinePlatform:[playStation,xbox,SwitchConsole,PC,miguplay],
                router:19,
                video:10,
            },
            {
                id:2,
                logo:require('../assets/home/Horizon-Zero-Dawn-logo.png'),
                title:"The third-person action role-playing game 'Horizon Zero Dawn'",
                subtitle:"Winner of the Best Visual Award at the 2016 Gamescom in Cologne, Germany, and the Excellence Award at TGS2017",
                onlinePlatform:[playStation,PC],
                router:18,
                video:11,
            },
            {
                id:3,
                logo:require('../assets/home/TowerOfFantasy-logo.png'),
                title:"Light sci-fi open-world game 'Tower of Fantasy'",
                subtitle:"High-degree-of-freedom world exploration gameplay, cinematic-level motion capture",
                onlinePlatform:[playStation,PC],
                router:17,
                video:9,
            },
            {
                id:4,
                logo:require('../assets/home/kof15-logo.png'),
                title:"The latest sequel in the King of Fighters series, 'King of Fighters 15'",
                subtitle:"SHATTER! Break through the imagination!",
                onlinePlatform:[playStation,miguplay],
                router:1,
                video:4,
            },
            {
                id:5,
                logo:require('../assets/home/ud-logo.png'),
                title:"Live-action interactive movie game 'Underdog Detective'",
                subtitle:"Little people break into the Divine Capital! Ridiculous solving strange cases!",
                onlinePlatform:[playStation,miguplay],
                router:3,
                video:5,
            },
            {
                id:6,
                logo:require('../assets/home/RhythmPlanet-logo.png'),
                title:"Cute and hilarious family game",
                subtitle:"Chinese first PS VR2 game",
                onlinePlatform:[playStation],
                router:2,
                video:3,
            },
            {
                id:7,
                logo:require('../assets/home/samurai-logo.png'),
                title:"Latest Title For Samurai Series",
                subtitle:"Brand New DLC character: Hibiki Takane Out Now!",
                onlinePlatform:[playStation],
                router:5,
                video:0,
            },
            {
                id:8,
                logo:require('../assets/home/kof14-logo.png'),
                title:"Classsic FTG《KOFXIV》",
                subtitle:"King's arrival equals they are invincible.",
                onlinePlatform:[playStation,miguplay],
                router:4,
                video:1,
            },
            {
                id:9,
                logo:require('../assets/home/WRC8-logo.png'),
                title:"World Rally Championship",
                subtitle:"Feel the joy of drifting under your skin.",
                onlinePlatform:[playStation,miguplay],
                router:9,
                video:2,
            },
            {
                id:10,
                logo:require('../assets/home/xt-en.png'),
                title:"Honkai: Star Rail",
                subtitle:"May This Journey Lead Us Starward HoYoverse space fantasy RPG",
                onlinePlatform:[playStation,PC,IOS,android],
                router:20,
                video:13,
            },
 

        ],
        gamestotal: '15',
        homeGames: [
            {
                id: '1',
                title: "IMMORTALS FENYS RISING",
                subtitle: "IMMORTALS FENYS RISING",
                bgUrl: require('../assets/game/game-FenyxRising_PC.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '2',
                title: "HORRIZON ZERO DAWN",
                subtitle: "HORRIZON ZERO DAWN",
                bgUrl: require('../assets/game/game-Horizon-Zero-Dawn_PC.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '3',
                title: "TOWER OF FANTASY",
                subtitle: "TOWER OF FANTASY",
                bgUrl: require('../assets/game/game-TowerOfFantasy_PC.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '4',
                title: "THE KING OF FIGHTERS XV",
                subtitle: "THE KING OF FIGHTERS XV ",
                bgUrl: require('../assets/game/game-KOF15.jpg'),
                ISBN: "Pending Approval",
                ISBNLink: "#"
            },
            
            {
                id: '5',
                title: "RHYTHM PLANET",
                subtitle: "RHYTHM PLANET",
                bgUrl: require('@/assets/game/game-RhythmPlanet.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '6',
                title: "Underdog Detective",
                subtitle: "Underdog Detective",
                bgUrl: require('@/assets/game/game-ud.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },

            {
                id: '7',
                title: "THE KING OF FIGHTERS XIV ",
                subtitle: "THE KING OF FIGHTERS XIV ",
                bgUrl: require('@/assets/game/game-KOF14.jpg'),
                ISBN: "ISBN 978-7-89988-867-4",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=159022"
            },
            
            {
                id: '8',
                title: "SAMURAI SHODOWN",
                subtitle: "SAMURAI SHODOWN",
                bgUrl: require('../assets/game/game-SAMURAISHODOWN.jpg'),
                ISBN: "ISBN 978-7-498-07482-9",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=176610"
            },
            {
                id: '9',
                title: "NBA 2K20",
                subtitle: "NBA 2K20",
                bgUrl: require('@/assets/game/game-NBA2K20.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '10',
                title: "NBA 2K19",
                subtitle: "NBA 2K19",
                bgUrl: require('../assets/game/game-NBA2K19.jpg'),
                ISBN: "ISBN 978-7-498-06512-2",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=175425"
            },
            {
                id: '11',
                title: "NBA 2K18",
                subtitle: "NBA 2K18",
                bgUrl: require('../assets/game/game-NBA2K18.jpg'),
                ISBN: "ISBN 978-7-498-01318-7",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=170298"
            },

            {
                id: '12',
                title: "WRC 8",
                subtitle: "WRC 8",
                bgUrl: require('../assets/game/game-wrc8.jpg'),
                ISBN: "Cloud Version",
                ISBNLink: "#"
            },
            {
                id: '13',
                title: "VOLUME",
                subtitle: "VOLUME",
                bgUrl: require('../assets/game/game-VOLUME.jpg'),
                ISBN: "ISBN 978-7-7979-1172-6",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=170127"
            },
            {
                id: '14',
                title: "SPELUNKER WORLD",
                subtitle: "SPELUNKER WORLD",
                bgUrl: require('../assets/game/game-SpelunkerWorld.jpg'),
                ISBN: "ISBN 978-7-7979-8817-9",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=170192"
            },
            {
                id: '15',
                title: "OBDUCTION",
                subtitle: "OBDUCTION",
                bgUrl: require('../assets/game/game-OBDUCTION.jpg'),
                ISBN: " ISBN 978-7-498-06435-6",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=175346"
            },
            {
                id: '16',
                title: "LIFE GOES ON",
                subtitle: "LIFE GOES ON ",
                bgUrl: require('../assets/game/game-Lifegoeson.jpg'),
                ISBN: "ISBN 978-7-7979-4020-7",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=164434"
            },


            {
                id: '17',
                title: "NIHILUMBRA",
                subtitle: "NIHILUMBRA",
                bgUrl: require('../assets/game/game-Nihilumbra.jpg'),
                ISBN: "ISBN 978-7-89400-666-0",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=159084"
            },
            {
                id: '18',
                title: "SUPER COMBO MAN",
                subtitle: "SUPER COMBO MAN",
                bgUrl: require('../assets/game/game-SUPERCOMBOMAN.jpg'),
                ISBN: "ISBN 978-7-7979-0661-6",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=170253"
            },
            {
                id: '19',
                title: "THE KING OF FIGHTERS97",
                subtitle: "THE KING OF FIGHTERS97",
                bgUrl: require('../assets/game/game-KOF97.jpg'),
                ISBN: "ISBN 978-7-89988-867-4",
                ISBNLink: "#"
            },
            {
                id: '20',
                title: "Honkai: Star Rail",
                subtitle: "May This Journey Lead Us Starward HoYoverse space fantasy RPG",
                bgUrl: require('../assets/game/xt-small.jpg'),
                ISBN: "",
                ISBNLink: "#"
            },

        ],
        mobileshow: '7',
        homeGamesMobile:[
            {
                id: '1',
                title: "IMMORTALS FENYS RISING",
                subtitle: "IMMORTALS FENYS RISING",
                bgUrl: require('../assets/game/game-FenyxRising_phone.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '2',
                title: "HORRIZON ZERO DAWN",
                subtitle: "HORRIZON ZERO DAWN",
                bgUrl: require('../assets/game/game-Horizon-Zero-Dawn_phone.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '3',
                title: "TOWER OF FANTASY",
                subtitle: "TOWER OF FANTASY",
                bgUrl: require('../assets/game/game-TowerOfFantasy_phone.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '4',
                title: "THE KING OF FIGHTERS XV",
                subtitle: "THE KING OF FIGHTERS XV ",
                bgUrl: require('../assets/game/game-KOF15_phone.jpg'),
                ISBN: "Pending Approval",
                ISBNLink: "#"
            },
            
            {
                id: '5',
                title: "RHYTHM PLANET",
                subtitle: "RHYTHM PLANET",
                bgUrl: require('@/assets/game/game-RhythmPlanet.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },
            {
                id: '6',
                title: "Underdog Detective",
                subtitle: "Underdog Detective",
                bgUrl: require('@/assets/game/game-ud_phone.jpg'),
                ISBN: "#",
                ISBNLink: "#"
            },

            {
                id: '7',
                title: "THE KING OF FIGHTERS XIV ",
                subtitle: "THE KING OF FIGHTERS XIV ",
                bgUrl: require('@/assets/game/game-KOF14.jpg'),
                ISBN: "ISBN 978-7-89988-867-4",
                ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=159022"
            },
            // {
            //     id: '5',
            //     title: "SAMURAI SHODOWN",
            //     subtitle: "SAMURAI SHODOWN",
            //     bgUrl: require('../assets/game/game-SAMURAISHODOWN.jpg'),
            //     ISBN: "ISBN 978-7-498-07482-9",
            //     ISBNLink: "http://www.nppa.gov.cn/nppa/publishing/serviceContent2.shtml?ID=176610"
            // },
            // {
            //     id: '6',
            //     title: "NBA 2K20",
            //     subtitle: "NBA 2K20",
            //     bgUrl: require('@/assets/game/game-NBA2K20.jpg'),
            //     ISBN: "#",
            //     ISBNLink: "#"
            // },
            // {
            //     id: '9',
            //     title: "WRC 8",
            //     subtitle: "WRC 8",
            //     bgUrl: require('../assets/game/game-wrc8.jpg'),
            //     ISBN: "Cloud Version",
            //     ISBNLink: "#"
            // },
        ],
        weiboNewsData: [
            {
              title: "Please enjoy their brilliance aglity through the  Motion Graphic for Team Secret Agent in KOFXV.",
              img: 'background-image:url(' + require('../assets/weibo/weiboNews_02.jpg') + ');',
              url: "https://weibo.com/5864259588/KniOG9PXB"
            },
            {
              title: "We now present you the BGM of Team Secret Agent in KOFXV, please enjoy.",
              img: 'background-image:url(' + require('../assets/weibo/weiboNews_04.jpg') + ');',
              url: "https://weibo.com/5864259588/KmH6H3Hi1"
            },
            {
              title: "Tips for WRC-Knowledge Point 2    In 1980s, it was when the more powerful Group B features 4-wheel drive replaced Group 2 and 4 with rear-guard.",
              img: 'background-image:url(' + require('../assets/weibo/weiboNews_06.jpg') + ');',
              url: "https://weibo.com/5864259588/KmA2YdeXr"
            },
            {
              title: "In KOFXV,Vanessa, Mary and Luong will get engaged as a member of Team Secret Agent.Let's expect their sensational performance.",
              img: 'background-image:url(' + require('../assets/weibo/weiboNews_08.jpg') + ');',
              url: "https://weibo.com/5864259588/KmePcggBN"
            }
          ]
    },
    Detail: {
        GAMENAME: "GAME NAME",
        DEVELOPER: "DEVELOPER",
        PLATFORM: "PLATFORM",

        gameDetail: {
           "1": {
                index: 1,
                name: "THE KING OF FIGHTERS XV",
                type: 2,
                headImg: require('@/assets/gameDetails/KOF15/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/KOF15/top/kof_video.mp4'),
                detailImg: require('@/assets/gameDetails/KOF15/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/KOF15/LOGO.png'),
                blockNum: 3,
                buyLink: "#",
                officialSiteLink: "https://kof.gamepoch.com/",
                videoLink: "//player.bilibili.com/player.html?aid=765999851&bvid=BV1sr4y1a7u5&cid=493784972&p=1",
                gameIntro: `The largest martial arts tournament in the world, "The King of Fighters", was disrupted by an unknown figure named "Welles" during the finals. Despite the chaos, the heroes were able to defeat him. Now, a new King of Fighters tournament is being organized. Meanwhile, Chizuru Kagura teamed up with Kyo Kusanagi and Iori Yagami to participate in the tournament and stop interference with the sealing of the Earth's will "Orochi".
                The revived martial artists who caused trouble in the previous tournament are also expected to participate. The tournament is filled with diverse and complex forces with different purposes. `,
                gameName: "THE KING OF FIGHTERS XV",
                gameDeveloper: "SNK",
                gamePlatform: "Console Games",
                copyright: "© SNK CORPORATION ALL RIGHTS RESERVED.",
                src: [
                    { index: 0, imgUrl: require('@/assets/gameDetails/KOF15/bottom/part1/part1.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1qQ4y1c7ow", title: "拳皇，不只是一个游戏，更是一个时代！" },
                    { index: 1, imgUrl: require('@/assets/gameDetails/KOF15/bottom/part2/part2.jpg'), vidioUrl: "https://www.bilibili.com/video/BV16T4y187E3", title: "拳皇制作人小田泰之为《拳皇15》国行首发送来祝福！" },
                    { index: 2, imgUrl: require('@/assets/gameDetails/KOF15/bottom/part3/part3.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1zZ4y1n74e", title: "《拳皇15》 携经典角色、全新剧情归来！" }
                ]
            },
            "3":{
                index: 3,
                name: "Underdog Detective",
                type: 2,
                headImg: require('@/assets/gameDetails/UnderdogDetective/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/UnderdogDetective/top/ud_video.mp4'),
                detailImg: require('@/assets/gameDetails/UnderdogDetective/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/UnderdogDetective/LOGO.png'),
                blockNum: 3,
                buyLink: "#",
                officialSiteLink: "https://underdogdetective.gamepoch.com/",
                videoLink: "//player.bilibili.com/player.html?aid=209615930&bvid=BV1Th411x74f&cid=453017062&p=1",
                gameIntro: `Underdog Detective is a new adaptation of the TV series ":Wind from the Luoyang". Set in the ninth year of Changsheng, it follows the conflicts between the "Spring and Autumn Way" led by the Dao Zun and the "Lian Fang" established by the court. These groups have been fighting continuously and have spread their disputes to Bad Wells, a lawless place in Luoyang City. 
                As the player, you will embark on a thrilling and comedic adventure in solving mysteries. You will incarnate as an ordinary person from Bad Wells and face traps, conspiracies, brotherhood, and the mysteries of identity. It's up to you to solve the mysteries and decide the fate of the characters.`,
                gameName: "Underdog Detective",
                gameDeveloper: "Tianjin Yunyun Technology and Bai Liu Film & Television jointly develop",
                gamePlatform: "Console Games",
                copyright: "© Tianjin Yunyun Technology Co., Ltd.ALL RIGHTS RESERVED.",
                src: [
                    { index: 0, imgUrl: require('@/assets/gameDetails/UnderdogDetective/bottom/part1/part1.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1J34y1X7PN", title: "不良井中的小世界" },
                    { index: 1, imgUrl: require('@/assets/gameDetails/UnderdogDetective/bottom/part2/part2.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1Uu411z7aP", title: "杜洵大作" },
                    { index: 2, imgUrl: require('@/assets/gameDetails/UnderdogDetective/bottom/part3/part3.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1qu411677P", title: "【主创面对面】互动影像和影视作品有什么区别？" }
                ]
            },
           "4": {
                index: 4,
                name: "THE KING OF FIGHTERS XIV",
                type: 2,
                headImg: require('@/assets/gameDetails/KOF14/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/KOF14/top/kof_video.mp4'),
                detailImg: require('@/assets/gameDetails/KOF14/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/KOF14/LOGO.png'),
                blockNum: 3,
                buyLink: "https://kof.gamepoch.com/buykof14",
                officialSiteLink: "https://kof.gamepoch.com/",
                videoLink: "//player.bilibili.com/player.html?aid=713331166&bvid=BV1YX4y1T77A&cid=270084473&page=1",
                gameIntro: "KOF XIV is the newest entry in the acclaimed THE KING OF FIGHTERS series of fighting games. Lead by veteran creator and FATAL FURY creator Yasuyuki Oda, KOF XIV takes the iconic gameplay that the series is known for while implementing new 3D visuals, a first for a mainline entry in the series! Featuring a robust roster of 50 characters in the base game along with 4 DLC characters, including both returning fan favorites and new characters, this entry is perfect for veterans and newcomers alike!",
                gameName: "THE KING OF FIGHTERS XIV",
                gameDeveloper: "SNK",
                gamePlatform: "Console Games",
                copyright: "© SNK CORPORATION ALL RIGHTS RESERVED.",
                src: [
                    { index: 0, imgUrl: require('@/assets/gameDetails/KOF14/bottom/part1/part1.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1PW411P7Ao", title: "GAMEPOCH / PS4<br/>Combo of OSWALD - KOFXIV DLC" },
                    { index: 1, imgUrl: require('@/assets/gameDetails/KOF14/bottom/part2/part2.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1PW411P7PB", title: "GAMEPOCH / PS4<br/>Chinese Performance - KOFXIV" },
                    { index: 2, imgUrl: require('@/assets/gameDetails/KOF14/bottom/part3/part3.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1PW411P7wQ", title: "GAMEPOCH / PS4<br/>K - KOFXIV" }
                ]
            },
          "5":  {
                index: 5,
                name: "SAMURAI SHODOWN",
                type: 2,
                headImg: require('@/assets/gameDetails/SAMURAISHODOWN/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/SAMURAISHODOWN/top/main.mp4'),
                detailImg: require('@/assets/gameDetails/SAMURAISHODOWN/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/SAMURAISHODOWN/LOGO.png'),
                blockNum: 3,
                buyLink: "http://www.snkchina.com.cn/",
                officialSiteLink: "http://www.snkchina.com.cn/",
                videoLink: "//player.bilibili.com/player.html?aid=667762798&bvid=BV1va4y1x7vc&cid=181807602&page=1",
                gameIntro: `SAMURAI series was born in 1993. The FTG series features cold weapon fighting includes sword and halberd had soon prevailed the world. And a decade’s deposition means a brand new flawless work ! This edition not only inherits the charming world outlook and game experience of the series of games, but also makes evolution for the extremely beautiful pictures. In the newly added functions, AI is able to resemble the fighting style of players and form “avatars”. The story was happened in Japan, one year before the original Samurai plot, aims to express the tale of different swordsmen who stick to their beliefs`,
                gameName: "SAMURAI SHODOWN",
                gameDeveloper: "SNK",
                gamePlatform: "Console Games",
                copyright: "© SNK CORPORATION ALL RIGHTS RESERVED.",
                src: [
                    { index: 0, imgUrl: require('@/assets/gameDetails/SAMURAISHODOWN/bottom/part1/part1.jpg'), vidioUrl: "https://weibo.com/tv/show/1034:4591056952426521?from=old_pc_videoshow", title: "Samurai Showdown DLC-Part 3" },
                    { index: 1, imgUrl: require('@/assets/gameDetails/SAMURAISHODOWN/bottom/part2/part2.jpg'), vidioUrl: "https://weibo.com/tv/show/1034:4615367511965734?from=old_pc_videoshow", title: "New Character Added In DLC- Cham Cham" },
                    { index: 2, imgUrl: require('@/assets/gameDetails/SAMURAISHODOWN/bottom/part3/part3.jpg'), vidioUrl: "https://weibo.com/tv/show/1034:4631261361406538?from=old_pc_videoshow", title: "New Character Added In DLC - Hibiki Takane" }
                ]
            },
           "13": {
                index: 13,
                name: "Life goes on ",
                type: 2,
                headImg: require('@/assets/gameDetails/Lifegoeson/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/Lifegoeson/top/main.mp4'),
                detailImg: require('@/assets/gameDetails/Lifegoeson/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/Lifegoeson/LOGO.png'),
                blockNum: 2,
                buyLink: "http://www.lifegoesongame.com/",
                officialSiteLink: "http://www.lifegoesongame.com/",
                videoLink: "//player.bilibili.com/player.html?aid=24547078&bvid=BV1PW411P7Nt&cid=41239625&page=1",
                gameIntro: `Life Goes On: Done to Death is a comically-morbid platformer where you guide heroic knights to their demise and use the dead bodies to solve puzzles. Wanting to live forever, a mighty king sends his army of knights to find the Cup of Life. On this quest, you will summon knight after knight to be brutally sacrificed. As you journey through treacherous and trap-ridden worlds, you’ll show no mercy to solve each challenging puzzle.`,
                gameName: "Life goes on ",
                gameDeveloper: "Infinite Monkeys Entertainment Ltd",
                gamePlatform: "Console Games",
                copyright: "© Infinite Monkeys Entertainment, Ltd. 2016",
                src: [
                    { index: 0, imgUrl: require('@/assets/gameDetails/Lifegoeson/bottom/part1/main.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1qt411f76v", title: "Life Goes On - Game Experience " },
                    { index: 1, imgUrl: require('@/assets/gameDetails/Lifegoeson/bottom/part2/main.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1PW411P7Nt", title: "Life Goes On - Trailer" }
                ]
            },
           "8": {
                index: 8,
                name: "NBA 2K18",
                type: 2,
                headImg: require('@/assets/gameDetails/NBA2K18/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/NBA2K18/top/NBA2K18.mp4'),
                detailImg: require('@/assets/gameDetails/NBA2K18/intro/NBA2K18.jpg'),
                logoUrl: require('@/assets/gameDetails/NBA2K18/NBA2K18LOGO.png'),
                blockNum: 3,
                buyLink: "https://2k.com/",
                officialSiteLink: "https://2k.com/",
                videoLink: "//player.bilibili.com/player.html?aid=14048557&bvid=BV1Yx411t7XY&cid=22941641&page=1",
                gameIntro: `NBA 2K18 is a new title for NBA series games under 2K games.
                As a classic basketball game, the game will lead players to experience the most real and exciting basketball game, as well as many big names who are waiting for players to fight.
                The game pays more attention to authenticity and details, making the character’s body shape, action and expression more realistic and vivid.
                Therefore, 2K sports carries out motion capture and face scanning for each and every player, so that the gamers can get a better experience in the process of playing.`,
                gameName: "NBA 2K18",
                gameDeveloper: "2K Sports",
                gamePlatform: "Console Games",
                copyright: "©2005-2017 Take-Two Interactive Software and its subsidiaries. 2K, the 2K logo, and Take-Two Interactive Software are all trademarks and/or registered trademarks of Take-Two Interactive Software, Inc. The NBA and NBA member team identifications are the intellectual property of NBA Properties, Inc. and the respective NBA member teams.©2017 NBA Properties, Inc. All rights reserved. The “PS” Family logo is a registered trademark and “PS4” is a trademark of Sony Interactive Entertainment Inc. All other trademarks are property of their respective owners. All rights reserved. *According to 2008-2017 Gamerankings.com and NPD Data.",
                src: [
                    { index: 0, imgUrl: require('@/assets/gameDetails/NBA2K18/bottom/part1/part1.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1RW411P7HJ", title: "Review on NBA 2K18 Highlights" },
                    { index: 1, imgUrl: require('@/assets/gameDetails/NBA2K18/bottom/part2/part2.jpg'), vidioUrl: "https://www.bilibili.com/video/BV19W411P7QL", title: "Review on NBA 2K18 Highlights 2" },
                    { index: 2, imgUrl: require('@/assets/gameDetails/NBA2K18/bottom/part3/part3.jpg'), vidioUrl: "https://www.bilibili.com/video/BV19W411P79c", title: "Review on NBA 2K18 Highlights 3" }
                ]
            },
           "7": {
                index: 7,
                name: "NBA 2K19",
                type: 2,
                headImg: require('@/assets/gameDetails/NBA2K19/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/NBA2K19/top/NBA2K19.mp4'),
                detailImg: require('@/assets/gameDetails/NBA2K19/intro/NBA2K19.jpg'),
                logoUrl: require('@/assets/gameDetails/NBA2K19/NBA2K19LOGO.png'),
                blockNum: 3,
                buyLink: "https://2k.com/",
                officialSiteLink: "https://2k.com/",
                videoLink: "//player.bilibili.com/player.html?aid=28787269&bvid=BV1zs411g75g&cid=49882069&page=1",
                gameIntro: `NBA 2K19 is a latest title for NBA 2K series developed by 2K sports.
                From the first-class picture quality and high playability, to the revolutionary game mode, and then to the fascinating open "community", NBA 2K has been constantly refreshing the definition of sports games in the past 20 years.
                This "NBA 2K19" will continue to break through the boundaries, let gamers get as close as possible to the real basketball experience, experience the purest basketball culture.`,
                gameName: "NBA 2K19",
                gameDeveloper: "2K Sports",
                gamePlatform: "Console Games",
                copyright: "©2005-2018 Take-Two Interactive Software and its subsidiaries. 2K, the 2K logo, and Take-Two Interactive Software are all trademarks and/or registered trademarks of Take-Two Interactive Software, Inc. The NBA and NBA member team identifications are the intellectual property of NBA Properties, Inc. and the respective NBA member teams. ©2018 NBA Properties, Inc. All rights reserved. “PlayStation family mark” and “PS4 logo” are registered trademarks or trademarks of Sony Interactive Entertainment Inc. All other trademarks are property of their respective owners. All rights reserved. *According to 2008-2018 Gamerankings.com and NPD Data.",
                src: [
                    { index: 0, imgUrl: require('@/assets/gameDetails/NBA2K19/bottom/part1/part1.jpg'), vidioUrl: "https://www.bilibili.com/video/BV14W411A7yv", title: "NBA 2K19 20th Anniversary Edition" },
                    { index: 1, imgUrl: require('@/assets/gameDetails/NBA2K19/bottom/part2/part2.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1eW411Q7oi", title: "NBA 2K19-My Career Mode Trailer" },
                    { index: 2, imgUrl: require('@/assets/gameDetails/NBA2K19/bottom/part3/part3.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1zs411g75g", title: "NBA 2K19-Trailer" }
                ]
            },
           "99": {
                index: 99,
                name: "Kerbal space program",
                type: 1,
                headImg: require('@/assets/gameDetails/KerbalSpaceProgram/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/KerbalSpaceProgram/top/main.mp4'),
                detailImg: require('@/assets/gameDetails/KerbalSpaceProgram/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/KerbalSpaceProgram/LOGO.png'),
                blockNum: 0,
                buyLink: "#",
                officialSiteLink: "https://www.kerbalspaceprogram.com/",
                videoLink: "//player.bilibili.com/player.html?aid=930946664&bvid=BV1hK4y1X7AH&cid=348784911&page=1",
                gameIntro: `Kerbal space program
                The Kerbal space program is a sandbox style Aerospace simulation game with high degree of freedom. 
                In the game, players can play as the Kerbal Aerospace worker in order to design, build and launch their own rockets, 
                space shuttle and sub orbital vehicles, and send them into orbit, and then explore the whole planetary system.`,
                gameName: "Kerbal space program",
                gameDeveloper: "Squad",
                gamePlatform: "Cloud Game",
                copyright: "© 2011-2021 Take-Two Interactive, Inc. All Rights Reserved.",
                src: []
            },
            "14": {
                index: 14,
                name: "Nihilumbra",
                type: 1,
                headImg: require('@/assets/gameDetails/Nihilumbra/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/Nihilumbra/top/main.jpg'),
                detailImg: require('@/assets/gameDetails/Nihilumbra/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/Nihilumbra/LOGO.png'),
                blockNum: 0,
                buyLink: "#",
                officialSiteLink: "https://beautifungames.com/",
                videoLink: "#",
                gameIntro: `Discover the beautiful world of Nihilumbra and join Born on his adventure to find himself whilst trying to escape from his inevitable curse. 
                Born was created from the absolute nothingness: The Void. But somehow he separates himself from the black emptiness and appears in the world. This is where his long odyssey begins, in which he will learn how to use the colors around him to gain powerful abilities and transform the world.`,
                gameName: "Nihilumbra",
                gameDeveloper: "Beautifungames",
                gamePlatform: "Console Games",
                copyright: "Copyright  ©2020 Published by Nacon and developed by KT Racing.",
                src: []
            }, 
           "15": {
                index: 15,
                name: "SUPER COMBOMAN ",
                type: 2,
                headImg: require('@/assets/gameDetails/SUPERCOMBOMAN/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/SUPERCOMBOMAN/top/main.jpg'),
                detailImg: require('@/assets/gameDetails/SUPERCOMBOMAN/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/SUPERCOMBOMAN/LOGO.png'),
                blockNum: 2,
                buyLink: "#",
                officialSiteLink: "https://indienova.com/game/super-comboman",
                videoLink: "#",
                gameIntro: `Enter a new Action Hero. An energetic islander with funked up mullet nugget, wearer of loud Hawaiian shirts, eater of chocolate chip cookies, and owner of a talking fanny pack (yeah, a talking fanny pack). His name is Struggles, and he’s the working class hero with an 'All You Can' attitude, a spinning pile driver, and fireball moves to match.
        
                Help Struggles battle an army of baddies and Mega bosses from a giant construction organization called DoDoCo. Traverse through vibrant levels, unlock powerful moves ripped straight from the pages of classic 2D fighter games' move lists and punch your co-workers through brick walls in order to collect a paycheck along the way. Help Struggles keep a roof over his and his brother's head in this action packed 2D adventure.`,
                gameName: "SUPER COMBOMAN ",
                gameDeveloper: "Interabang Entertainment",
                gamePlatform: "Console Games",
                copyright: "© 2015 INTERABANG ENTERTAINMENT INC All Rights Reserved",
                src: [
                    { index: 0, imgUrl: require('@/assets/gameDetails/SUPERCOMBOMAN/bottom/part1/main.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1ex41147is", title: "SUPER COMBOMAN" },
                    { index: 1, imgUrl: require('@/assets/gameDetails/SUPERCOMBOMAN/bottom/part2/main.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1PW411P7Nq", title: "SUPER COMBOMAN - Trailer" }
                ]
            },
           "9": {
                index: 9,
                name: "WRC 8",
                type: 1,
                headImg: require('@/assets/gameDetails/WRC8/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/WRC8/top/wrc8.mp4'),
                detailImg: require('@/assets/gameDetails/WRC8/intro/WRC8.jpg'),
                logoUrl: require('@/assets/gameDetails/WRC8/WRC8LOGO.png'),
                blockNum: 0,
                buyLink: "#",
                officialSiteLink: "https://buy.wrcthegame.com/",
                videoLink: "//player.bilibili.com/player.html?aid=930976566&bvid=BV1rK4y1X7mk&cid=348782078&page=1",
                gameIntro: `FIA World Rally Championship ©2020 Published by Nacon and developed by KT Racing. An official product of the FIA World Rally Championship. All rights reserved. `,
                gameName: "WRC 8",
                gameDeveloper: "Kylotonn",
                gamePlatform: "Console Games",
                copyright: "Copyright  ©2020 Published by Nacon and developed by KT Racing.",
                src: []
            }, 
           "10": {
                index: 10,
                name: "VOLUME",
                type: 1,
                headImg: require('@/assets/gameDetails/VOLUME/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/VOLUME/top/main.mp4'),
                detailImg: require('@/assets/gameDetails/VOLUME/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/VOLUME/LOGO.png'),
                blockNum: 0,
                buyLink: "#",
                officialSiteLink: "http://www.volumegame.net/",
                videoLink: "https://www.gamepoch.cn/",
                gameIntro: `Locksley doesn't kill. That would be far too easy. Instead, he commits his crimes through stealth. Sneaking, distracting, avoiding. He is never seen, and seldom heard. As he grows in popularity and notoriety, so will his inventory. An arsenal of gadgets await discovery in a quest to rob from the rich and give to the unheard.`,
                gameName: "VOLUME",
                gameDeveloper: "Bithell Games",
                gamePlatform: "PS4 PSV PSVR",
                copyright: "© 2015 Mike Bithell Games Limited.  ‘Volume’ and ‘Mike Bithell Games’ are trademarks of Mike Bithell Games Limited. All rights reserved",
                src: []
            }, 
           "11": {
                index: 11,
                name: "Spelunker World",
                type: 1,
                headImg: require('@/assets/gameDetails/SpelunkerWorld/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/SpelunkerWorld/top/main.mp4'),
                detailImg: require('@/assets/gameDetails/SpelunkerWorld/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/SpelunkerWorld/LOGO.png'),
                blockNum: 0,
                buyLink: "#",
                officialSiteLink: "https://spelunker.gamepoch.com/?id=5",
                videoLink: "https://www.gamepoch.cn/",
                gameIntro: `Embark on an underground adventure! Spelunker World is a free-to-play side-scrolling action game. Play as underground explorer "Spelunker" and venture in to the mysterious dungeons! Enjoy online multiply for up to 6 people! A new pet introduced! Change of outfits! New Characters! What awaits at the deepest parts of the caves?`,
                gameName: "Spelunker World",
                gameDeveloper: "Tozai Games",
                gamePlatform: "Console Games",
                copyright: `© 2018 SQUARE ENIX CO, LTD. 版权所有
                © 1983-2018 Timothy G Martin 与Tozai, Inc. 版权所有
                探险家斯皮兰卡是Square Enix Holdings Co., Ltd注册的一个商标
                Tozai Games是Tozai, Inc.注册的一个商标,在美国和其他国家注册或受保护
                SQUARE ENIX和SQUARE ENIX的标志已被注册为Square Enix Holdings Co, Ltd.的商标`,
                src: []
            },
            "12": {
                index: 12,
                name: "OBDUCTION",
                type: 2,
                headImg: require('@/assets/gameDetails/OBDUCTION/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/OBDUCTION/top/main.jpg'),
                detailImg: require('@/assets/gameDetails/OBDUCTION/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/OBDUCTION/LOGO.png'),
                blockNum: 1,
                buyLink: "#",
                officialSiteLink: "https://www.gog.com/game/obduction",
                videoLink: "#",
                gameIntro: `As you walk beside the lake on a cloudy night, a curious, organic artifact falls from the starry sky and inexplicably, without asking permission, transports you across the universe. You’ve been abducted from your cozy existence and added into an alien landscape with pieces of Earth from unexpected times and places. `,
                gameName: "OBDUCTION",
                gameDeveloper: "Cyan Inc.",
                gamePlatform: "PS(VR)",
                copyright: "® Copyright 2017 Cyan, Inc . All rights reserved. Obduction ® and Cyan are registered trademarks of Cyan, Inc. Legendary VR logo © 2017 Legendary. Unreal, Unreal Engine, the circle-U logo and the Powered By Unreal Engine Logo are trademarks or registered trademarks of Epic Games, Inc. in the United States and elsewhere.",
                src: [
                    { index: 0, imgUrl: require('@/assets/gameDetails/OBDUCTION/bottom/part1/main.jpg'), vidioUrl: "https://www.bilibili.com/video/BV1yb411872h", title: "OBDUCTION - Trailer" }

                ]
            },
            "16": {
                index: 16,
                name: "THE KING OF FIGHTERS97 ",
                type: 1,
                headImg: require('@/assets/gameDetails/KOF97/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/KOF97/top/kof97.mp4'),
                detailImg: require('@/assets/gameDetails/KOF97/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/KOF97/LOGO.png'),
                blockNum: 0,
                buyLink: "#",
                officialSiteLink: "https://www.snk-corp.co.jp/us/",
                videoLink: "//player.bilibili.com/player.html?aid=57131740&bvid=BV1dx411d7Je&cid=99771907&page=1",
                gameIntro: `THE KING OF FIGHTERS '97
                KOF '97 is an arcade fighting game released by SNK company in 1997, which is very popular in China. Compared with the first three versions of KOF games, great improvements drips in all aspects. It is a mature work of KOF series. Up to now, KOF '97 is still popular in arcade halls all over the country.`,
                gameName: "THE KING OF FIGHTERS97 ",
                gameDeveloper: "SNK",
                gamePlatform: "Cloud Game",
                copyright: "© SNK CORPORATION ALL RIGHTS RESERVED.",
                src: []
            },
          "2":  {
                index: 2,
                name: "RhythmPlanet",
                type: 2,
                headImg: require('@/assets/gameDetails/RhythmPlanet/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/RhythmPlanet/top/RhythmPlanet.mp4'),
                detailImg: require('@/assets/gameDetails/RhythmPlanet/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/RhythmPlanet/RhythmPlanetLOGO.png'),
                blockNum: 3,
                buyLink: "#",
                officialSiteLink: "https://www.gamepoch.com/detail?id=14",
                videoLink: "//player.bilibili.com/player.html?aid=24546941&bvid=BV1PW411P7FK&cid=41239345&page=1",
                gameIntro: `"Rhythm Planet" is a cute and hilarious game developed by Aoga Technology and published by GAMEPOCH. The game perfectly combines music rhythm with new features of PSVR2, such as adaptive triggers, head-mounted vibration feedback, and surround sound, allowing players to enjoy the fun on dozens of "super parties".
        
                If you are experiencing PSVR2 for the first time, "Rhythm Planet" is a great introductory experience. The game is easy to pick up and designed for family fun, suitable for friends' gatherings and family entertainment. With a good rhythm sense, you can dominate the party.
                
                Whether you are a game novice or a veteran player, "Rhythm Planet" will bring you endless fun and excitement, making your PSVR2 experience more colorful. Come and experience this cute and hilarious game!`,
                gameName: "RhythmPlanet",
                gameDeveloper: "Aoga Technology",
                gamePlatform: "PS VR2",
                copyright: "©2023 Aoga Technology",
                src: [
                    { index: 0, imgUrl: require('@/assets/gameDetails/RhythmPlanet/bottom/part1/part1.jpg'), vidioUrl: "https://video.weibo.com/show?fid=1034:4903129007980611", title: "PS VR2 “Rhythem Planet”海外同步上线" },
                    { index: 1, imgUrl: require('@/assets/gameDetails/RhythmPlanet/bottom/part2/part2.jpg'), vidioUrl: "https://video.weibo.com/show?fid=1034:4872351012290611", title: "首款国行PlayStation-VR2游戏《牧场星球》" },
                    { index: 2, imgUrl: require('@/assets/gameDetails/RhythmPlanet/bottom/part3/part3.jpg'), vidioUrl: "https://video.weibo.com/show?fid=1034:4876683229200433", title: "PS VR2《牧场星球》线下体验日实况" }
                ]
            }, 
            "6":{
                index: 6,
                name: "NBA 2K20",
                type: 2,
                headImg: require('@/assets/gameDetails/NBA2K20/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/NBA2K20/top/NBA2K20.mp4'),
                detailImg: require('@/assets/gameDetails/NBA2K20/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/NBA2K20/NBA2K20LOGO.png'),
                blockNum: 3,
                buyLink: "#",
                officialSiteLink: "https://www.gamepoch.com/detail?id=15",
                videoLink: "//player.bilibili.com/player.html?aid=67976239&bvid=BV1DJ411c7Tv&cid=117821186&page=1",
                gameIntro: "《NBA 2K20》是篮球体育游戏《NBA 2K》系列的续作，这一作将以突破性的游戏模拟以及无与伦比的玩家控制重新定义运动游戏的可能性。",
                gameName: "《NBA 2K20》",
                gameDeveloper: "2K Sports",
                gamePlatform: "Console Game",
                copyright: `©2005-2019 Take-Two Interactive Software, Inc. and its subsidiaries.2K, the 2K logo, and Take-Two Interactive Software are all trademarks and/orregisteredtrademarks of Take-Two I
                nteractive Software, Inc. The NBA and NBAmember team identifications are the intellectual property of NBA Properties,Inc. and the respective NBA member teams. 
                ©2019 NBA Properties, Inc. AllRights Reserved. Officially licensed product of the National Basketball PlayersAssociation.`,
                src: [
                    { index: '0', imgUrl: require('@/assets/gameDetails/NBA2K20/bottom/part1/part1.jpg'), vidioUrl: "https://weibo.com/tv/show/1034:4479432140718095?from=old_pc_videoshow", title: "NBA 2K20 MT模式" },
                    { index: '1', imgUrl: require('@/assets/gameDetails/NBA2K20/bottom/part2/part2.jpg'), vidioUrl: "https://weibo.com/tv/show/1034:4471348357955593?from=old_pc_videoshow", title: "NBA2K20 全明星宣传片" },
                    { index: '2', imgUrl: require('@/assets/gameDetails/NBA2K20/bottom/part3/part3.jpg'), vidioUrl: "https://weibo.com/tv/show/1034:4453185385857037?from=old_pc_videoshow", title: "NBA2K20-圣诞-麦迪卡包" }
                ]
            },
            "17":{
                index: 17,
                name: "Tower of Fantasy",
                type: 1,
                headImg: require('@/assets/gameDetails/TowerOfFantasy/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/TowerOfFantasy/top/kof97.mp4'),
                detailImg: require('@/assets/gameDetails/TowerOfFantasy/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/TowerOfFantasy/LOGO.png'),
                blockNum: 0,
                buyLink: "#",
                officialSiteLink: "https://www.toweroffantasy-global.com/home.html",
                videoLink: "//player.bilibili.com/player.html?aid=57131740&bvid=BV1dx411d7Je&cid=99771907&page=1",
                gameIntro: `Set hundreds of years in the future on the distant planet of Aida, the shared open-world MMORPG, anime-infused sci-fi adventure Tower of Fantasy from developer Hotta Studio and publisher Level Infinite, is now available on PC and mobile platforms globally. Players will be able to experience an anime-inspired post-apocalyptic sci-fi art style, freeform character development, and exciting combat through thrilling battles and exciting open-world exploration.`,
                gameName: "Tower of Fantasy",
                gameDeveloper: "Hotta Studio",
                gamePlatform: "Console Game",
                copyright: "©2022-2024 Proxima Beta Pte. Ltd. All rights reserved.",
                src: []
            },
            "18":{
                index: 18,
                name: "Horizon Zero Dawn",
                type: 1,
                headImg: require('@/assets/gameDetails/Horizon/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/Horizon/top/kof97.mp4'),
                detailImg: require('@/assets/gameDetails/Horizon/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/Horizon/LOGO.png'),
                blockNum: 0,
                buyLink: "#",
                officialSiteLink: "https://www.guerrilla-games.com/games",
                videoLink: "//player.bilibili.com/player.html?aid=57131740&bvid=BV1dx411d7Je&cid=99771907&page=1",
                gameIntro: `In an era where Machines roam the land and mankind is no longer the dominant species, a young hunter named Aloy embarks on a journey to discover her destiny. In a lush, post-apocalyptic world where nature has reclaimed the ruins of a forgotten civilization, pockets of humanity live on in primitive hunter-gatherer tribes. Their dominion over the new wilderness has been usurped by the Machines – fearsome mechanical creatures of unknown origin.`,
                gameName: "Horizon Zero Dawn",
                gameDeveloper: "Guerrilla Games",
                gamePlatform: "Console Game",
                copyright: "©2024 Sony Interactive Entertainment Inc. Developed by Guerrilla.",
                src: []
            },
            "19":{
                index: 19,
                name: "Immortals Fenyx Rising",
                type: 1,
                headImg: require('@/assets/gameDetails/FenyxRising/top/adaptivity.jpg'),
                headVideo: require('@/assets/gameDetails/FenyxRising/top/kof97.mp4'),
                detailImg: require('@/assets/gameDetails/FenyxRising/intro/main.jpg'),
                logoUrl: require('@/assets/gameDetails/FenyxRising/LOGO.png'),
                blockNum: 0,
                buyLink: "#",
                officialSiteLink: "https://www.ubisoft.com/en-gb/game/immortals-fenyx-rising",
                videoLink: "//player.bilibili.com/player.html?aid=57131740&bvid=BV1dx411d7Je&cid=99771907&page=1",
                gameIntro: `The fate of the world is at stake – you are the gods’ last hope. Play as Fenyx, a new winged demigod on a quest to save the Greek gods and their home from a dark curse. Take on mythological beasts, master the legendary powers of the gods and defeat Typhon, the deadliest Titan in Greek mythology, in an epic fight for the ages. `,
                gameName: "Immortals Fenyx Rising",
                gameDeveloper: "UBISOFT ENTERTAINMENT SA",
                gamePlatform: "Console Game",
                copyright: "© 2024 Ubisoft Entertainment. All Rights Reserved. Immortals Fenyx Rising, Ubisoft and the Ubisoft logo are registered or unregistered trademarks of Ubisoft Entertainment in the U.S. and/or other countries.",
                src: []
            },
            "20":{
                        index: 20,
                        name: "Honkai: Star Rail",
                        type: 1,
                        headImg: require('@/assets/gameDetails/FenyxRising/top/adaptivity.jpg'),
                        headVideo: require('@/assets/gameDetails/FenyxRising/top/kof97.mp4'),
                        detailImg: require('@/assets/gameDetails/XT/xt-detail.jpg'),
                        logoUrl: require('@/assets/gameDetails/XT/xt-en.png'),
                        blockNum: 0,
                        buyLink: "#",
                        officialSiteLink: "#",
                        videoLink: "//player.bilibili.com/player.html?aid=57131740&bvid=BV1dx411d7Je&cid=99771907&page=1",
                        gameIntro: `Honkai: Star Rail is a new HoYoverse space fantasy RPG.
Hop aboard the Astral Express and experience the galaxy's infinite wonders filled with adventure and thrills.
Players will meet new companions across various worlds and maybe even run into some familiar faces. Overcome the struggles together caused by Stellaron and unravel the hidden truths behind it! May this journey lead us starward!`,
                        gameName: "Honkai: Star Rail",
                        gameDeveloper: "COGNOSPHERE",
                        gamePlatform: "PlayStation",
                        copyright: "©2024 COGNOSPHERE版权所有",
                        src: []
                    },
        }
    }

}


// WEBPACK FOOTER //
// ./src/lang/en.js